import ButtonV2 from "../../../components/ui/button/v2";
import { X } from "lucide-react";

interface RenderSelectedPillsProps {
    data: string[];
    onRemove: (index: number) => void;
};

const RenderSelectedPills = (props: RenderSelectedPillsProps) => {
    return (
        <div className="flex flex-wrap gap-2">
            {props.data.map((referenceId: string, index: number) => (
                <div
                    key={index.toString()}
                    className="inline-flex items-center justify-center rounded-md bg-gray-700 px-2 py-1 text-xs font-medium text-white"
                >
                    <span>{referenceId}</span>
                    <ButtonV2
                        variant="ghost"
                        size="sm"
                        onClick={() => props.onRemove(index)}
                        prefix={<X width="12" height="12" />}
                        className="ml-1 p-0 w-4 h-4 flex items-center justify-center rounded-full hover:bg-gray-600"
                    />
                </div>
            ))}
        </div>
    );
};

export {
    RenderSelectedPills
}